import { useContext, useEffect, useTransition } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { Button } from 'react-bootstrap';
import PageRow from './PageRow';
import { PagesContext } from '../../../contexts/PagesContext';
import Paginator from '../../../components/Paginator';
import CheckPageStatuses from '../CheckPageStatuses';

const UserSites = () => {
  const {
    pageDatas,
    getPageList,
    paginationPageInfo,
    total,
    links,
    listLoading,
  } = useContext(PagesContext);

  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    getPageList({ is_user_sites: true });
  }, [getPageList]);

  const changePage = (page: number) => {
    getPageList({ page });
  };

  const handleRefresh = async () => {
    startTransition(() => {
      getPageList({ is_user_sites: true });
    });
  };

  return (
    <div className="main">
      <main
        style={{
          overflowY: 'auto',
          height: 'calc(100vh - 65px)',
        }}
      >
        <CheckPageStatuses noAutoRefresh />

        {listLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <div className="container-fluid p-3">
            <div className="mb-3">
              <h3 className="h3 d-inline align-middle">サイト管理</h3>
            </div>
            <div className="row mt-2">
              <div className="col-12">
                <div className="card">
                  <div className="card-header">
                    <div className="d-flex align-items-center gap-1">
                      <div className="flex-fill d-flex align-items-center justify-content-between">
                        <h5 className="card-title">サイト一覧</h5>
                        <Button
                          size="sm"
                          disabled={isPending}
                          onClick={handleRefresh}
                        >
                          一覧を更新
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive border-bottom">
                      <table className="table table-striped table-hover table-bordered table-nowrap">
                        <thead>
                          <tr>
                            <th className="text-center" style={{ width: '5%' }}>No</th>
                            <th className="text-center">公開</th>
                            <th className="text-center">種別</th>
                            <th>公開日時</th>
                            <th>サイト名</th>
                            <th className="text-center"><span className="text-sm">ページ数</span></th>
                            <th>URL</th>
                            <th className="text-center" style={{ width: '100px' }}>操作</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pageDatas.map((pageData) => (
                            <PageRow
                              key={pageData.id}
                              pageData={pageData}
                            />
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer bg-white pt-1 pb-3">
                      <div className="d-flex mt-2">
                        <div className="page-item-count">
                          <div style={{ fontSize: 14 }}>
                            {`全 ${total} 件中 ${paginationPageInfo.from ?? 0} 〜 ${paginationPageInfo.to ?? 0} 件を表示`}
                          </div>
                        </div>
                        <Paginator currentPage={paginationPageInfo.current_page} changePage={changePage} links={links} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default UserSites;
